import {
  DashboardTypes,
  agencyEnum,
  countryEnum,
  datatype,
  detailedDimensionsDetail,
  filterDetail,
  filtertype,
  localQuery,
  metric,
  metricFunction,
  queryInput,
} from 'API';
import { Kpis, TxtContainer } from 'components/Main/Main.styles';
import { useClientContext } from 'context/ClientContext';
import React, { useContext, useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { KPIholder } from './TV.styles';

import { useCampaignContext } from 'context/CampaignContext';
import { TVBVODJSON, TVJSON, useDataQuery } from 'customHooks/useDataQuery';
import { useTheme } from 'styled-components';
// import { useActiveCampaign } from 'customHooks/useActiveCampaign';
import AuthContext from 'context/AuthContext';
import { PublishContext } from 'context/PublishContext';
import { getEndDate, getStartDate } from 'methods/dateMethods';
import { useTemplateContext } from 'context/TemplateContext';
import KPIComponent from '../KPIComponent';

type Props = {};

const BVOD_KPI = (props: Props) => {
  const { REACT_APP_AGENCY } = process.env;
  const { user } = useContext(AuthContext);
  const { publishedData, updateOLArray } = useContext(PublishContext);
  const { updateTemplatePlaceholderList } = useTemplateContext();
  const { activeOrganization, organizationList } = useClientContext();
  const { campaignList, activeSubCampaign, activeCampaign } = useCampaignContext();
  const theme = useTheme();
  const [query, setQuery] = useState<queryInput>();

  // const [activeCamp] = useActiveCampaign({ campaignList: campaignList, orgList: organizationList })
  const activeCamp = activeCampaign;
  const activeSubCamp = activeSubCampaign;
  const username = user?.username;
  const Organization = activeOrganization?.Organization;
  const ClientCountry = activeCamp?.ClientCountry;

  const publishedKPI = publishedData?.find((element: any) => element.position === 'BVODKPI1');
  const publishedOutputLocation = publishedKPI?.outputlocation;

  useEffect(() => {
    if (/* activeSubCamp && Object.keys(activeSubCamp).length > 0 && */ activeCamp?.authorized === true) {
      //METRICS DATA
      const metrics: metric[] = [
        {
          column: 'cost',
          name: 'cost',
          aggregation: metricFunction.SUM,
          id: '1',
        },
      ];

      // FILTER(CAMPAIGN DATA)

      const filter: filterDetail = {
        column: 'campaign_id',
        filter: {
          filtertype: filtertype.EQUAL,
          datatype: datatype.NUMBER,
          value: activeCampaign?.campaignId.toString(),
        },
      };

      // DATE DATA

      const localQuery: localQuery = {
        filters: [filter],
        metrics: metrics,
        // dimensions: ['subcampaign_id', "primary_target_group"],
        detailedDimensions: [
          {
            column: 'campaign_id',
            name: 'campaign_id',
            hidden: false,
            id: '22',
          },
        ],
        preview: 300,
        orderBy: ['1', '22'],
      };
      const newQuery: queryInput = {
        query: localQuery,
        views: [
          // {
          //   viewName:
          //     Organization === 'DEMO-Organization'
          //       ? 'fozzie_callisto_tv_demo'
          //       : `fozzie_callisto_tv_${REACT_APP_AGENCY}`,
          //   database:
          //     ClientCountry === 'DK'
          //       ? 'data_lake_denmark'
          //       : ClientCountry === 'SE'
          //         ? 'data_lake_sweden'
          //         : ClientCountry === 'FI'
          //           ? 'data_lake_finland'
          //           : 'data_lake_norway',
          // },
          // {
          //   viewName:
          //     Organization === 'DEMO-Organization'
          //       ? 'fozzie_callisto_planned_tv_demo'
          //       : `fozzie_callisto_planned_tv_${REACT_APP_AGENCY}`,
          //   database:
          //     ClientCountry === 'DK'
          //       ? 'data_lake_denmark'
          //       : ClientCountry === 'SE'
          //         ? 'data_lake_sweden'
          //         : ClientCountry === 'FI'
          //           ? 'data_lake_finland'
          //           : 'data_lake_norway',
          // },
          {
            viewName:
              Organization === 'DEMO-Organization'
                ? 'fozzie_adform_bvod_demo'
                : `fozzie_adform_bvod_${REACT_APP_AGENCY}`,
            database:
              ClientCountry === 'DK'
                ? 'data_lake_denmark'
                : ClientCountry === 'SE'
                  ? 'data_lake_sweden'
                  : ClientCountry === 'FI'
                    ? 'data_lake_finland'
                    : 'data_lake_norway',
          },
          {
            viewName:
              Organization === 'DEMO-Organization'
                ? 'fozzie_campaign_manager_bvod_demo'
                : `fozzie_campaign_manager_bvod_${REACT_APP_AGENCY}`,
            database:
              ClientCountry === 'DK'
                ? 'data_lake_denmark'
                : ClientCountry === 'SE'
                  ? 'data_lake_sweden'
                  : ClientCountry === 'FI'
                    ? 'data_lake_finland'
                    : 'data_lake_norway',
          },
          {
            viewName:
              Organization === 'DEMO-Organization'
                ? 'fozzie_marathon_bvod_tracking_demo'
                : `fozzie_marathon_bvod_tracking_${REACT_APP_AGENCY}`,
            database:
              ClientCountry === 'DK'
                ? 'data_lake_denmark'
                : ClientCountry === 'SE'
                  ? 'data_lake_sweden'
                  : ClientCountry === 'FI'
                    ? 'data_lake_finland'
                    : 'data_lake_norway',
          },
        ],
        jobnumber: 'ANNA0027',
        clients: [
          {
            country: countryEnum[activeCamp?.ClientCountry as keyof typeof countryEnum],
            client: activeCamp?.ClientCode as string,
          },
        ],
        date: { from: getStartDate(36), to: getEndDate() },
        user: {
          name: username,
          agency: agencyEnum[`${REACT_APP_AGENCY?.toUpperCase()}` as keyof typeof agencyEnum],
          country: countryEnum.DK,
        },
      };
      setQuery(newQuery);
    }
  }, [ClientCountry, REACT_APP_AGENCY, activeCamp, Organization, username, activeCampaign?.campaignId]);

  const [data, queryStatus, error, queryId, outputLocation] = useDataQuery({
    query: query,
    querySource: 'TVBVOD KPI',
    publishedOutputLocation: publishedOutputLocation,
  });

  const jsonDataObject = data as TVBVODJSON;

  const cost = jsonDataObject?.cost ?? 0;

  useEffect(() => {
    if (outputLocation) {
      const placeholdersObject = {
        position: 'BVODKPI1',
        outputlocation: outputLocation,
      };
      //  console.log("placeholdersObject", placeholdersObject)
      updateOLArray(placeholdersObject);
    }
  }, [outputLocation, updateOLArray]);
  const kpiData = [
    { title: 'Budget', subtitle: 'Realized', ctc: cost, componentID: 'BVODKPI1' },
    { title: 'Reach', subtitle: 'Realized', location: 'BVOD', componentID: 'BVODKPI2' },
    { title: 'Persons', subtitle: 'Total Number', location: 'BVOD', componentID: 'BVODKPI3' },
    { title: 'Frequency', subtitle: 'Average', location: 'BVOD', componentID: 'BVODKPI4' },
  ];

  return (
    <>
      {queryStatus === 'FAILED' ? (
        <Kpis>
          <KPIholder style={{ padding: '1vw' }}>
            <p>Something went wrong, please reload the page and try again </p>
          </KPIholder>
        </Kpis>
      ) : (
        <Kpis>
          {kpiData
            .filter((kpi) =>
              activeCampaign?.authorized
                ? kpi
                : publishedData.some((el) => kpi.ctc || publishedData.some((el) => el?.position === kpi.componentID)),
            )
            .map((kpi, index) => (
              <KPIComponent
                key={index}
                queryStatus={'NOT STARTED'}
                title={kpi.title}
                subtitle={kpi.subtitle}
                location={kpi.location}
                componentID={kpi.componentID}
                ctc={kpi.ctc}
                theme={theme}
              />
            ))}
        </Kpis>
      )}
    </>
  );
};

export default BVOD_KPI;
